import type { FaireProductEntity } from "../../entity_types/product";

export const p_gga4uyyvjn: FaireProductEntity = {
  token: "p_gga4uyyvjn",
  type: "product",
  name: "Conscientious Objector",
  brandToken: "b_6su5v1sirt",
  brandName: "Highwire Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/4d6f8a426c50bd96aa505540a933b054dc1ec1c2cf517013881696f122319b54.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3c30f248f7a854ca58c6a2f534ecbe31bdb2c35e8b1107b70619cab4a10b97c5.png",
    "https://cdn.faire.com/fastly/035871698bd8e7ae7ce96c12034393288c4016a8a4e59facf135e755bcd79117.png",
    "https://cdn.faire.com/fastly/ec72b19e5f0dc1a253241c99b5f99e1baef54370d00f7789742990438b84632e.png",
    "https://cdn.faire.com/fastly/0a5abc4e8e3475a248459875ce9393817ba6f335fcae274d75546e44515fa585.png"
  ],
  priceDollars: 13.12,
  description: "Seasonal—Fresh—Organic\n\n\nBackstory: Conscientious Objector was named as a tribute to the customers who demanded certified organic coffees back when many roasters resisted their (at the time) inferior cup quality. They sent the message loudly and clearly they wanted coffee to be responsibly grown and sourced and the industry was compelled to listen. Kudos to those who lead with their conscience.\n\nOrigins: This will always be certified organic coffees, but the flavor will change quite a bit from season to season, as we use this place in our lineup to explore a much wider range of flavors and origins to just highlight what we think is the best organic coffee to be found in any given season.\n\nPairings: Pairs well with passionate protest music by artists like M.I.A., Nina Simone, Crosby, Stills, Nash & Young, and Bikini Kill. Play loud.\n\nBrew: Use a scale and grind fresh. Use 16 grams of water at 200°F for each gram of coffee.",
  tags: [],
  msrpDollars: 18.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:57.679Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
